<template>
	<div class="am-environment"
		:class="{
			'is-idle': !init
		}"
	>
		<div class="am-environment__top">
			<div class="am-environment__container">
				<am-text class="am-environment__title" type="subtitle">
					Ambientes e Lazer
				</am-text>
			</div>

			<am-map-image
				class="am-environment__map"
				image="https://condominiodasamericas.com.br/images/blueprint-clean.jpg"
				:markers="images"
				:zoom="-1.5"
				:max-zoom="3"
				:min-zoom="-1.5"
				@click="onClick"
			/>

			<div class="am-environment__container">
				<am-text class="am-environment__caption" type="caption">
					Clique nos pinos ou nas legendas abaixo para ver imagens ampliadas dos ambientes.
				</am-text>
			</div>
		</div>

		<div class="am-environment__footer">
			<div class="am-environment__container">
				<div class="am-environment__swiper swiper-container" v-if="viewport == 'smartphone'">
					<div class="am-environment__wrapper swiper-wrapper">
						<div class="am-environment__slide swiper-slide"
							v-for="(items, index) in columns"
							:key="`slide-${index}`"
						>
							<div
								class="am-environment__item"
								v-for="(item, index) in items"
								@click="onClick(item)"
							>
								<am-text>
									{{ item.id }}. {{ item.name }}
								</am-text>
							</div>
						</div>
					</div>
				</div>

				<div class="am-environment__navigation" v-show="viewport == 'desktop'">
					<div class="am-environment__column" v-for="items in columns">
						<div
							class="am-environment__item"
							:class="{ 'is-disabled': !item.image }"
							v-for="(item, index) in items"
							@click="onClick(item)"
						>
							<am-text>
								{{ item.id }}. {{ item.name }}
							</am-text>
							<am-icon name="magnifier" size="xs" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AMText from '@/components/atoms/AMText'
import AMIcon from '@/components/atoms/AMIcon'
import AMMapImage from '@/components/molecules/AMMapImage'
import Swiper from 'swiper'
import { mapGetters } from 'vuex'

export default {
	components: {
		'am-text': AMText,
		'am-icon': AMIcon,
		'am-map-image': AMMapImage
	},

	computed: {
		...mapGetters({
			viewport: 'viewport/getCurrent'
		}),

		columns() {
			return this.chunkArray(this.images, 5)
		},

		images() {
			let images = [],
				index = 0

			this.items.forEach(item => {
				images.push({
					id: item.id,
					name: item.name,
					index: item.image ? index : null,
					image: item.image,
					path: item.image,
					caption: item.name,
					lat: item.lat,
					lng: item.lng
				})

				if (item.image)
					index++
			})

			return images
		},

		gallery() {
			let images = []
			
			this.items.forEach(item => {
				if (item.image)
					images.push({
						caption: item.name,
						path: item.image
					})
			})

			return images
		}
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},
		items: {
			type: Array,
			default: () => ([
				{
					id: 1,
					name: 'Salão de Festas',
					image: require('@/assets/images/environment/01 - Condominio_das_Americas_SalaoFestas.jpg'),
					lat: -139.095703125,
					lng: 302.310546875
				},
				{
					id: 2,
					name: 'Salão Gourmet',
					image: require('@/assets/images/environment/02 - Condominio_das_Americas_EspacoGourmet.jpg'),
					lat: -185.29296875,
					lng: 279.90234375
				},
				{
					id: 3,
					name: 'Espaço Kids',
					image: require('@/assets/images/environment/03 - Condominio_das_Americas_KidsClub.jpg'),
					lat: -223.29296875,
					lng: 264.40234375
				},
				{
					id: 4,
					name: 'Piscinas',
					image: require('@/assets/images/environment/04 - Condominio_das_Americas_AereaPiscina.jpg'),
					lat: -193.79296875,
					lng: 307.90234375
				},
				{
					id: 5,
					name: 'Spa e Academia',
					image: require('@/assets/images/environment/05 - Condominio_das_Americas_Academia.jpg'),
					lat: -220.79296875,
					lng: 302.90234375
				},
				{
					id: 6,
					name: 'Guarita de Segurança',
					image: require('@/assets/images/environment/06 - Condominio_das_Americas_Guarita.jpg'),
					lat: -311.623046875,
					lng: 632.474609375
				},
				{
					id: 7,
					name: 'Campo de Futebol',
					image: require('@/assets/images/environment/07 - Condominio_das_Americas_CampoFutebol.jpg'),
					lat: -252.123046875,
					lng: 303.474609375
				},
				{
					id: 8,
					name: 'Ginásio Poliesportivo',
					image: require('@/assets/images/environment/08 - Condominio_das_Americas_Quadra.jpg'),
					lat: -282.123046875,
					lng: 309.474609375
				},
				{
					id: 9,
					name: 'Quadra de Tênis',
					image: require('@/assets/images/environment/09 - Condominio_das_Americas_QuadraTenis.jpg'),
					lat: -265.345703125,
					lng: 265.94140625
				},
				{
					id: 10,
					name: 'Minicampo',
					image: require('@/assets/images/environment/10 - Condominio_das_Americas_MiniCampo.jpg'),
					lat: -242.123046875,
					lng: 253.474609375
				},
				{
					id: 11,
					name: 'Caixa D`água',
					image: require('@/assets/images/environment/11 - Condominio_das_Americas_CasteloDagua.jpg'),
					lat: -59.369140625,
					lng: 325.357421875
				},
				{
					id: 12,
					name: 'Terraço de Apoio a Piscina',
					image: require('@/assets/images/environment/12 - Condominio_das_Americas_LazerPiscina.jpg'),
					lat: -207.630859375,
					lng: 290.99609375
				},
				{
					id: 13,
					name: 'Bloco Administrativo',
					image: require('@/assets/images/environment/13 - Condominio_das_Americas_Administracao.jpg'),
					lat: -338.587890625,
					lng: 617.25390625
				},
				{
					id: 14,
					name: 'Área do Parque das Américas',
					image: require('@/assets/images/environment/14 - Condominio_das_Americas_VistaParque.jpg'),
					lat: -195.826171875,
					lng: 791.8125
				},
			])
		}
	},

	mounted() {
		if (this.viewport == 'smartphone')
			this.initSwiper()

		if (this.init)
			this.start()
	},

	destroyed() {
		if (this.viewport == 'smartphone')
			this.destroySwiper()
	},

	watch: {
		viewport(value) {
			if (value == 'smartphone')
				this.initSwiper()
			else
				this.destroySwiper()
		},

		init(value) {
			if (value)
				this.start()
		}
	},

	methods: {
		start() {
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-environment__top'), 1.5, {
				y: "+=100",
				opacity: 0,
				ease: Power2.easeOut
			})

			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-environment__footer'), 1.5, {
				y: "+=100",
				opacity: 0,
				delay: .5,
				ease: Power2.easeOut
			})
		},

		chunkArray(myArray, chunk_size) {
			let results = [],
				data = JSON.parse(JSON.stringify(myArray))

			while (data.length) {
				results.push(data.splice(0, chunk_size))
			}

			return results
		},

		initSwiper() {
			this.$nextTick(() => {
				this.swiper = new Swiper(this.$el.querySelector('.am-environment__swiper'), {
					slidesPerView: 'auto'
				})

				this.$nextTick(() => {
					this.swiper.update()
				})
			})
		},

		destroySwiper() {
			if (this.swiper)
				this.swiper.destroy()
		},

		onClick(item) {
			if (!item.image)
				return

			this.$emit('gallery', {
				images: this.gallery,
				current: item.index
			})
		}
	}
}
</script>

<style lang="scss">
.am-environment{
	background: white;
	display: flex;
	flex-flow: column;
	transition: .3s $easeInOutQuad;
	&__container{
		flex-shrink: 0;
		width: 100%;
		@include outer-container;
	}
	&__top{
		flex: 1;
		display: flex;
		flex-flow: column;
		@include grid-container;
	}
	&__title,
	&__caption{
		@include grid-column(6);
	}
	&__title{
		margin-top: 24px;
		margin-bottom: 24px;
		flex-shrink: 0;
	}
	&__caption{
		display: none;
		padding: 24px 0;
		flex-shrink: 0;
	}
	&__map{
		clear: both;
		flex: 1;
		min-height: inherit;
	}
	&__swiper{
		width: 100%;
	}
	&__footer{
		clear: both;
		flex-shrink: 0;
	}
	&__navigation{
		display: flex;
		justify-content: space-between;
		@include grid-column(6);
	}
	&__slide{
		padding: 36px;
		box-sizing: border-box;
		width: 90% !important;
		&:before{
			content: "";
			position: absolute;
			top: 15px;
			left: 15px;
			right: 15px;
			bottom: 15px;
			border-radius: 17px;
			box-shadow: 0 0px 15px rgba(black, .16);
			background: white;
			z-index: -1;
		}
	}
	&__item{
		position: relative;
		padding-right: 32px;
		margin-bottom: 4px;
		cursor: pointer;
		transition: .2s $easeInOutQuad;
		&.is-disabled{
			pointer-events: none
		}
		.am-text{
			color: $c-gray;
			transition: .2s $easeInOutQuad;
			font-weight: 400;
		}
	}

	&.is-idle{
		opacity: 0;
	}

	@include grid-media($desktop-grid) {
		display: flex;
		flex-flow: column;
		&__top{
			flex: 1;
			display: flex;
			align-items: center;
		}
		&__container{
			width: 100%;
		}
		&__caption{
			display: block;
		}
		&__footer{
			box-shadow: 0 0 15px rgba(black, .1);
			padding: 32px 0;
			flex-shrink: 0;
		}
		&__map{
			width: 100%;
			margin: 0;
		}
		&__item{
			&:after{
				content: "";
				position: absolute;
				width: 0%;
				bottom: 0;
				height: 1px;
				background: $c-brown;
				transition: .2s $easeInOutQuad;
			}
			&:not(.is-disabled):hover{
				&:after{
					width: 100%;
				}
				.am-icon{
					opacity: 1;
					transform: translateY(-50%) scale(1);
				}
				.am-text{
					color: $c-brown;
				}
			}
			.am-icon{
				position: absolute;
				top: 50%;
				right: 0;
				opacity: 0;
				transition: .2s $easeInOutQuad;
				transform: translateY(-50%) scale(2);
			}
		}
	}
}
</style>
